import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {FaqsComponent} from './faqs.component';
import {AddFaqComponent} from './add-faq/add-faq.component';

const routes: Routes = [
  {
    path: 'faqs',
    component: FaqsComponent,
    data: {animation: 'faqs'}
  },
  {
    path: 'faq/add',
    component: AddFaqComponent,
    data: {animation: 'faq/add'}
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FaqsRoutingModule { }
